import { useReleaseNoteWatcher } from "../../hooks/useReleaseNoteWatcher";

/**
 * Renders nothing; raises the release-note "Refresh" toast and runs the
 * mobile catch-up. Mounted beside PusherInitializer inside /admin/*.
 */
export function ReleaseNoteWatcher(): null {
  useReleaseNoteWatcher();
  return null;
}

export default ReleaseNoteWatcher;
